import axios from 'axios';

export const loginAPI = async (reqData) => {
    // return await axios.post(`${process.env.REACT_APP_GEMFINDER_URL_API}/login/`, reqData);
    // return await axios.post(`${process.env.REACT_APP_STONE_SEARCH_URL_API}/api/v1/login/`, reqData);
    return await axios.post(`${process.env.REACT_APP_GEMFINDER_URL_API}/api/v1/login/`, reqData);
    // return await axios.post(`${process.env.REACT_APP_KUSHDIAMOND_URL_API}/api/login/`, reqData);
};
